import axios from 'axios';

const api = axios.create({
  baseURL: 'https://origenesvenezuela.com/origin/api',
  //baseURL: 'http://localhost:4000/origin/api/',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('origenes_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
